
import * as React from "react";
import { IComboBox, IComboBoxOption, IDropdownOption, IList } from "@fluentui/react";
import * as accounting from "accounting";
import validator from "validator";

import { BetriebInvalidCharRegex, constVarianteKeyAbmeldung, constVarianteKeyAenderung, constVarianteKeyErstanforderung, constVarianteKeySonderfall, EmailInvalidCharRegex, FirmaInvalidCharRegex, FirmaMaxLength, FormFieldsCommon, GebaeudeInvalidCharRegex, months, NameInvalidCharRegex, NumberInvalidCharRegex, PhoneInvalidCharRegex, requiredMessage } from "../../CommonConstants";
import { IRequestCommonState } from "./RequestCommonState";
import { IFormField, IGenericOption } from "../../CommonTypes";
import axios from "axios";
import { IRequestCommonProps } from "./RequestCommonProps";
import { IsNullOrWhitespace } from "../../UtilityFuncs1";


// changing to arrow function leads to problem that "this" might be null
export async function onChangeTextBoxBasic(this: React.Component<IRequestCommonProps, IRequestCommonState>,
                                           event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
                                           newValue?: string | undefined) {
    const value: string = event.currentTarget.value;
    const field: string = event.currentTarget.id;            // was .name

    let result: string = event.currentTarget.value;

    if (field === "Betrieb") {
      result = value.replace(BetriebInvalidCharRegex, "");
    }

    if (field === "Gebaeude") {
      result = value.replace(GebaeudeInvalidCharRegex, "");
    }

    // if (name == "KontoEnergieverrechnung" ||
    //     name == "ANMStellenBezeichnung" || 
    //     name == "SonderfallsBeschreibung" ||
    //     name == "BemerkungAntragsteller")    
    // {
    //   // new
    // }

    const state = { ...this.state };
    state.currentRecord[field] = result;
    this.setState(state);
  } 



export async function onChangeTextBox_NumberFld(this: React.Component<IRequestCommonProps, IRequestCommonState>,
                                                event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
                                                newValue?: string | undefined) {                              
    const value: string = event.currentTarget.value;
    const field: string = event.currentTarget.id;            // was .name

    let result = value.replace(NumberInvalidCharRegex, "");
    if (result !== "") {
      result = numberFormater(result);
    }

    const state = { ...this.state };
    state.currentRecord[field] = result;
    this.setState(state);
  };


export function onInputChangeComboBoxFirma(this: React.Component<IRequestCommonProps, IRequestCommonState>,
                                           value: string, composing: boolean): string | void  {
    const state = { ...this.state };
    const newValue = value.replace(FirmaInvalidCharRegex, "").substring(0, FirmaMaxLength);
    let errMessage = "";
    if (newValue !== value) {
      errMessage = "50 Zeichen maximal; nur Buchstaben, Zahlen, und folgende Sonderzeichen: -&()'.";
    }
    state.currentRecordErrors.AntragstellerFirma = errMessage;
    this.setState(state);
    return newValue;
  }


export async function onChangeTextBox_NameFld(this: React.Component<IRequestCommonProps, IRequestCommonState>,
                                              event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
                                              newValue?: string | undefined) {

    const value: string = event.currentTarget.value;
    const field: string = event.currentTarget.id;            // was .name

    const result = value.replace(NameInvalidCharRegex, "");

    const state = { ...this.state };
    state.currentRecord[field] = result;
    this.setState(state);
  }


export async function onChangeTextBox_EmailFld(this: React.Component<IRequestCommonProps, IRequestCommonState>,
                                               event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
                                               newValue?: string | undefined) {

    // debugger;

    const value: string = event.currentTarget.value;
    const field: string = event.currentTarget.id;            // was .name

    const result = value.replace(EmailInvalidCharRegex, "");

    const state = { ...this.state };
    state.currentRecord[field] = result;
    this.setState(state);
  }


export async function onChangeTextBox_PhoneFld(this: React.Component<IRequestCommonProps, IRequestCommonState>,
                                               event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
                                               newValue?: string | undefined) {

    const value: string = event.currentTarget.value;
    const field: string = event.currentTarget.id;            // was .name

    // debugger;
    let result = value.replace(PhoneInvalidCharRegex, "");
    result = result.length > 0 ? result[0] + result.slice(1).replace("+", "") : result;  // only when + is allowed
    result = result.replace("--", "-");
    result = result.replace("  ", " ");

    const state = { ...this.state };
    state.currentRecord[field] = result;
    this.setState(state);
  }



export async function onChangeDropdown(this: React.Component<IRequestCommonProps, IRequestCommonState>,
                                       event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption<any> | undefined, index?: number | undefined)  {
    // debugger;
    const state = { ...this.state };

    state.currentRecord[(event.target as HTMLDivElement).id] = option?.key;  // currentTarget.id is wrong, strange suffix added
    // await this.setState(state);
    this.setState(state);
  };  


export async function onSelectMonthCalendarNested(this: React.Component<IRequestCommonProps, IRequestCommonState>,
                                                  date: Date, name: string)  {
  const state = { ...this.state };
  state.showCalendar = false;

  var year = date.getFullYear();
  // var month = parseInt(date.getMonth()) + 1;
  var month = date.getMonth() + 1;

  var monthString = months.filter((x) => x.key === month)[0].text;

  state.currentRecord[name] = monthString + " " + year;
  state.currentRecordErrors[name] = "";
  // await this.setState(state);
  this.setState(state);
};

export async function toggleShowCalendar(this: React.Component<IRequestCommonProps, IRequestCommonState>)  {
  this.setState({ showCalendar: !(this.state as IRequestCommonState).showCalendar })
}; 

export async function hideCalendar(this: React.Component<IRequestCommonProps, IRequestCommonState>) {
  this.setState({ showCalendar: false })
};

async function dummyAxios():Promise<string> {
  return "Dummy Response";
}

export async function onSubmitNested(this: React.Component<IRequestCommonProps, IRequestCommonState>, 
                                     apiEndpoint: string, noFormDisable: boolean) {    // don't disable form after submission? (true is useful for testing)
                                     
  const ValidationOfRequiredPassed = await FormValidateTheRequired.bind(this)();

  if (ValidationOfRequiredPassed === false) {
    this.setState({ 
      submitMessage: "" 
    });      
    return;
  }

  this.setState({ 
    showSpinner: true,
  })

  let currentRecord = (this.state as any).currentRecord;
  currentRecord.Antragsdatum = new Date();

  const thisApiEndpoint = apiEndpoint;

  await (this.props.noSubmit ? dummyAxios() : axios.post(thisApiEndpoint, currentRecord))       
    .then((response) => {
      console.log(response);
      // debugger;
      this.setState({ 
          showSpinner: false,
          formReadOnly: !noFormDisable,
          submitMessage: "Ihr Antrag wurde abgesendet."
       });
      
    })
    .catch((error) => {
      console.log(error);
      // debugger;
      this.setState({ 
          showSpinner: false,
          submitMessage: error.message 
       });
    });

  };
  

export async function onChangeAntragstellerFirma(this: React.Component<IRequestCommonProps, IRequestCommonState>, 
                                                 event: React.FormEvent<IComboBox>, 
                                                 option?: IComboBoxOption | undefined, index?: number | undefined, 
                                                 value?: string | undefined) {
  const state: IRequestCommonState = { ...this.state };

  const name: string = "AntragstellerFirma";

  if (index !== undefined) {
    console.log(`${name} ComboBox: Option selected`);
    state.currentRecord[name] = option?.key;
  } else {
    if (value !== undefined && value.trim() !== "") {
      console.log(`${name} ComboBox: FreeText entered`);
      const NewOption: IGenericOption = {
        key: value,
        text: value,
      };

      const OptionResource = "AntragstellerFirmaOPS";

      state[OptionResource].push(NewOption);
      state.currentRecord[name] = value;

    } else {
      console.log(`${name} ComboBox: FreeText emptied`);
      state.currentRecord[name] = "";
    }
  }

  // debugger;

  let isISG: boolean = this.props.companies.filter((c) => c.Name === state.currentRecord.AntragstellerFirma)[0]?.IstISG;  // !SK! Changed to .Name from .Key

  if (!isISG) {
    state.companyIsISG = false;
    state.currentRecord.KontoEnergieverrechnung = "";
    state.currentRecordErrors.KontoEnergieverrechnung = "";
  } else {
    state.companyIsISG = true;
  }

  this.setState(state);
};


export function CompanyIsISG(this: React.Component<IRequestCommonProps, IRequestCommonState>): boolean {
  return this.state.companyIsISG;
}  

export function FormIsSN(this: React.Component<IRequestCommonProps, IRequestCommonState>): boolean {
  console.log("this.state.currentRecord.constructor.name =", this.state.currentRecord.constructor.name);
  return (this.state.currentRecord.constructor.name == "StromNetzRecord");
}  

export function FormIsSNOtherUser(this: React.Component<IRequestCommonProps, IRequestCommonState>): boolean {
  return (this.state.currentRecord.constructor.name == "StromNetzRecord" && this.state.currentRecord.AntragstellerIsAnschlussnehmer === false);
}  

export function VarianteIsErstAnforderung(this: React.Component<IRequestCommonProps, IRequestCommonState>): boolean {
  return (this.state.currentRecord.AntragsVariante === constVarianteKeyErstanforderung);
}  

export function VarianteIsAenderung(this: React.Component<IRequestCommonProps, IRequestCommonState>): boolean {
  return (this.state.currentRecord.AntragsVariante === constVarianteKeyAenderung);
}  

export function VarianteIsAbmeldung(this: React.Component<IRequestCommonProps, IRequestCommonState>): boolean {
  return (this.state.currentRecord.AntragsVariante === constVarianteKeyAbmeldung);
}  

export function VarianteIsSonderfall(this: React.Component<IRequestCommonProps, IRequestCommonState>): boolean {
  return (this.state.currentRecord.AntragsVariante === constVarianteKeySonderfall);
}

export function VarianteIsErstAnforderungOrAenderung(this: React.Component<IRequestCommonProps, IRequestCommonState>): boolean {
  return (this.state.currentRecord.AntragsVariante === constVarianteKeyErstanforderung ||
          this.state.currentRecord.AntragsVariante === constVarianteKeyAenderung);
}  

export function VarianteIsAenderungOrAbmeldung(this: React.Component<IRequestCommonProps, IRequestCommonState>): boolean {
  return (this.state.currentRecord.AntragsVariante === constVarianteKeyAenderung ||
          this.state.currentRecord.AntragsVariante === constVarianteKeyAbmeldung);
} 

export function BetriebsweiseIsDiskontinuierlich(this: React.Component<IRequestCommonProps, IRequestCommonState>): boolean {
  return (this.state.currentRecord.Betriebsweise === "diskontinuierlich");
}

// export function FormValidateTheRequired(fields: IFormField[]): boolean {
export function FormValidateTheRequired(this: React.Component<IRequestCommonProps, IRequestCommonState>): boolean {
  const state = { ...this.state };
  let result: boolean = true;

  (this.props.formFields as IFormField[]).forEach(f => {
    console.log(`Evaluating field '${f.Id}'...`);
    // debugger;

    if ((f.used == null // parameter omitted, default is true
      || f.used === true 
      || (typeof f.used === 'function' && f.used.bind(this)() === true)) 
        && 
      // f.required 
      (f.required === true 
      || (typeof f.required === 'function' && f.required.bind(this)() === true))
        && 
      IsNullOrWhitespace(state.currentRecord[f.Id])) {
      console.log(`Validating field '${f.Id}'...`);
      state.currentRecordErrors[f.Id] = f.ErrPrefix ? f.ErrPrefix + requiredMessage : f.Label + requiredMessage;
      result = false;
    }
  });

  this.setState(state);

  return result;
}


export async function FieldValidateTheRequired(this: React.Component<IRequestCommonProps, IRequestCommonState>, name: string, label: string): Promise<boolean> {

    let result: boolean = true;
  
    let errorMessage: string;

    if (IsNullOrWhitespace(this.state.currentRecord[name])) {
      errorMessage = label + requiredMessage;
      result = false;
    } 
    else {
      errorMessage = "";
      result = true;

    }

    this.setState((prevState) => ({currentRecordErrors: {...prevState.currentRecordErrors, [name]: errorMessage}}));
    return result;
};


export function ValidateOnBlur(this: React.Component<IRequestCommonProps, IRequestCommonState>,
                               event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) {
  // debugger;

  FieldValidate.bind(this)((this.props.formFields as IFormField[]).find(f => f.Id == event.currentTarget.id));
}

export async function FieldValidate(this: React.Component<IRequestCommonProps, IRequestCommonState>,
                                    field: IFormField) {

  // debugger;
  let filled: boolean = false;
  const prefix: string = field.ErrPrefix ? field.ErrPrefix : field.Label

  // if (field.FieldType == constFTypeTextField || field.FieldType == constFTypeComboBox || field.FieldType == constFTypeDropdown) {   // no need to check, only called for those types
    filled = await FieldValidateTheRequired.bind(this)(field.Id, prefix);
  // }

  if (filled) {
    if (field.Id === "AntragstellerEmail" || field.Id === "AnschlussnehmerEmail") {
      await EmailPatternValidate.bind(this)(field.Id, prefix);
    }

    if (field.Id === "AntragstellerTelefon" || field.Id === "AnschlussnehmerTelefon") {
      await PhonePatternValidate.bind(this)(field.Id, prefix);
    }
  }
}

  // export const delay = (ms: number) => new Promise((res) => setTimeout(res, ms)); 

export const numberFormater = (string: string) => {
  var string_Arr = string.split(",");
  var fixed_input = string_Arr[0];
  var result = fixed_input.replace(/[.]/g, "");
  // var fixed = accounting.formatNumber((result, {
  //   precision: 0,
  //   thousand: ".",
  // });
  var fixed = accounting.formatNumber(parseInt(result),  0, ".");
  var decimal = "";
  if (string_Arr.length === 2) {
    decimal = string_Arr[1];
    if (decimal.length > 2) decimal = decimal.substring(0, 2);
    return fixed + "," + decimal;
  } else {
    return fixed;
  }
};

export async function EmailPatternValidate(this: React.Component<IRequestCommonProps, IRequestCommonState>,
                                           name: string, label: string) {
  const state = { ...this.state };
  if (validator.isEmail(state.currentRecord[name]) === false) {
    state.currentRecordErrors[name] = label + " Format ist ungültig";
    // await this.setState(state);
    this.setState(state);
    return false;
  } else {
    //clear field level error
    state.currentRecordErrors[name] = "";
    // await this.setState(state);
    this.setState(state);
    return true;
  }
};

export async function PhonePatternValidate(this: React.Component<IRequestCommonProps, IRequestCommonState>,
                                           name: string, label: string) {
  const state = { ...this.state };
  var errorFlag = false;
  //Don't start with 00
  var FirstTwo = state.currentRecord[name].substring(0, 2);
  if (FirstTwo === "00") {
    var errorFlag = true;
  }
  if (errorFlag === true) {
    // state.currentRecordErrors[name] = label + " muss nicht ausländisch sein";
    state.currentRecordErrors[name] = "Bitte verwenden Sie '+' bei einer Ländervorwahl";
    // await this.setState(state);
    this.setState(state);
    return false;
  } 
  else {        
    state.currentRecordErrors[name] = "";                    // clear field level error
    // await this.setState(state);
    this.setState(state);
    return true;
  }
};
    